export default {"src":"/_next/static/media/tiktok-light.f1b14eab.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};